module.exports = require("@swa-ui/design-tokens/src/generated/platforms/scss/helpcenter-light.module.scss");